import TextField from "@mui/material/TextField";
import { forwardRef } from "react";

const CustomPhoneInput = (props, ref) => {
  return (
    <TextField
      {...props}
      inputRef={ref}
      fullWidth
      size="small"
      label="Phone Number"
      variant="outlined"
      name="phone"
    />
  );
};
export default forwardRef(CustomPhoneInput);
